import { render, staticRenderFns } from "./welcome-theme.vue?vue&type=template&id=524ee0fd&scoped=true"
import script from "./welcome-theme.vue?vue&type=script&lang=js"
export * from "./welcome-theme.vue?vue&type=script&lang=js"
import style0 from "./welcome-theme.vue?vue&type=style&index=0&id=524ee0fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524ee0fd",
  null
  
)

export default component.exports